export const GET_MY_COURSE_ROUTES_REQUEST = "GET_MY_COURSE_ROUTES_REQUEST";
export const GET_MY_COURSE_ROUTES_SUCCESS = "GET_MY_COURSE_ROUTES_SUCCESS";
export const GET_MY_COURSE_ROUTES_FAIL = "GET_MY_COURSE_ROUTES_FAIL";
